// ProfilePage.tsx
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import './ProfilePage.css';

import ProfileBanner from './ProfileBanner';
import TopPicksRow from './TopPicksRow';
import ContinueWatching from './ContinueWatching';
import netflixSound from '../netflix-sound.mp3';

type ProfileType = 'recruiter' | 'tech_enthusiast' | 'stalker' | 'adventurer'; // <-- CHANGED

const ProfilePage: React.FC = () => {
  const location = useLocation();
  const backgroundGif =
    location.state?.backgroundGif ||
    "https://media.giphy.com/media/xT9IgzoKnwFNmISR8I/giphy.gif";
  const { profileName } = useParams<{ profileName: string }>();

  // Update the array used for validation
  const profile = ['recruiter', 'tech_enthusiast', 'stalker', 'adventurer'].includes(profileName!) // <-- CHANGED
    ? (profileName as ProfileType)
    : 'recruiter';

  // Play sound once per profile
  useEffect(() => {
    const hasPlayed = sessionStorage.getItem(`soundPlayed-${profile}`);
    if (!hasPlayed) {
      const audio = new Audio(netflixSound);
      audio.play().catch(err => console.log('Audio blocked:', err));
      sessionStorage.setItem(`soundPlayed-${profile}`, 'true');
    }
  }, [profile]);

  return (
    <>
      <div className="profile-page" style={{ backgroundImage: `url(${backgroundGif})` }}>
        <ProfileBanner />
      </div>
      <TopPicksRow profile={profile} />
      <ContinueWatching profile={profile} />
    </>
  );
};

export default ProfilePage;